import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { PublicHoliday } from '../models/PublicHoliday'
import { PublicHolidayForm } from '../forms/PublicHolidayForm'
import { PublicHolidayFilter } from '../filters/PublicHolidayFilter'
import { PublicHolidayService } from '../services/PublicHolidayService'

export const usePublicHolidayStore: KsStoreHook<PublicHoliday, PublicHolidayForm, PublicHolidayFilter> = createKsStore({
  id: 'publicHolidays',
  modelClass: PublicHoliday,
  formClass: PublicHolidayForm,
  filterClass: PublicHolidayFilter,
  service: PublicHolidayService,
  uniqueField: 'code',
  labelField: (item) => item.label || item.code || `Jour férié #${item.id}`,
  signalREventName: 'PublicHolidayModel',
  isReferential: true
})
